import { render, staticRenderFns } from "./log-access.vue?vue&type=template&id=724f55b6&scoped=true&lang=pug"
import script from "./log-access.vue?vue&type=script&lang=js"
export * from "./log-access.vue?vue&type=script&lang=js"
import style0 from "./log-access.vue?vue&type=style&index=0&id=724f55b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f55b6",
  null
  
)

export default component.exports